import { render, staticRenderFns } from "./PayFundsMain.vue?vue&type=template&id=28fbc550&"
import script from "./PayFundsMain.vue?vue&type=script&lang=js&"
export * from "./PayFundsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports